//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import { apiParams } from '@/const/const';
import { compressAccurately } from 'image-conversion';

export default {
    name: 'uploadImg',
    data() {
        return {
            itemWidth: 0,
            iconClose2: require('@/assets/images/wx_sc_oringe.png') // 关闭图标
        };
    },
    props: {
        value: {
            type: Array,
            default: null
        }
    },
    watch: {
        value: {
            handler(newValue, oldValue) {
                this.$previewRefresh();
            },
            immediate: true
        }
    },
    methods: {
        /**
         * 选择图片回调, 压缩图片
         * @param {Object} e
         */
        getImg(e) {
            if (!e.target.files[0]) return;
            let files = e.target.files;
            for (let i = 0; i < files.length; i++) {
                let file  = files[i];
                // let file = new File([files[i]], files[i].name, {type: files[i].type})
                let imgItem = {
                    imgSrc: URL.createObjectURL(file),
                    iconClose: this.iconClose2,
                    flag: '1',
                    progress: 0, // 进度
                    error: false, // 是否上传失败
                    file: file,
                    compress: true, // 是否正在压缩
                    compressTag: false  // 压缩标志，压缩成功的图片不再压缩 会遇到压缩完成图片大于512的
                };
                this.value.splice(this.value.length - 1, 0, imgItem);
                this.uploadImg(imgItem)
            }
            // document.getElementById('inputFile').value = '';
        },
        /**
         * 异步压缩图片
         * @param {Object} imgItem
         */
        async compress(imgItem) {
            imgItem.compress = true;
            let res = await compressAccurately(imgItem.file, 512);
            let newFile = new File([res], imgItem.file.name, {type: res.type});
            imgItem.file = newFile;
            imgItem.compress = false;
            imgItem.compressTag = true;
            this.uploadImg(imgItem)
        },
        /**
         * 上传图片
         * @param {Object} file
         */
        uploadImg(imgItem) {
            if (imgItem.file.size / 1024 > 512 && !imgItem.compressTag) {
                this.compress(imgItem);
                return
            }
            imgItem.compress = false;
            imgItem.imgSrc = URL.createObjectURL(imgItem.file);
            imgItem.error = false;
            imgItem.progress = 0;
            this.getToken(imgItem, token => {
                const axiosInstance = axios.create({
                    withCredentials: false
                }); //withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
                let data = new FormData();
                data.append('token', token); //七牛需要的token，叫后台给，是七牛账号密码等组成的hash
                data.append('file', imgItem.file);
                let companyId = apiParams.companyId || this.getUrlParams('companyId') || 'Unknown';
                let dateStr = new Date().Format('yyyyMMdd');
                let randStr = Math.random(5).toString(36).substr(2) || 'Unknown';
                let extName = imgItem.file.name.substring(imgItem.file.name.lastIndexOf('.') + 1) || '.jpg'; //后缀名
                let key = companyId + '_' + dateStr + '_' + randStr + '.' + extName;
                data.append('key', key);
                axiosInstance({
                    method: 'POST',
                    url: 'https://up-z2.qbox.me', //上传地址
                    data: data,
                    timeout: 30000, //超时时间，因为图片上传有可能需要很久
                    onUploadProgress: progressEvent => {
                        // 是上传进度，可以用来添加进度条
                        let imgLoadPercent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        // 由于上传进度满足100但是key还没返回，在返回url那里将进度赋值100，这里100改为99
                        imgItem.progress = imgLoadPercent < 100 ? imgLoadPercent : 99;
                    }
                })
                .then(data => {
                    let key = data.data.key;
                    imgItem.progress = 100;
                    imgItem.imgSrc = 'http://img.aohaisoft.com/' + key;
                    imgItem.error = false;
                })
                .catch(function(err) {
                    //上传失败
                    imgItem.error = true;
                });
            });
        },
        /**
         * 获取上传token
         */
        getToken(imgItem, success, fail) {
            success = success || function() {};
            fail = fail || function() {};

            const storage = window.localStorage;
            let qnToken = storage['qToken'];
            if (qnToken) {
                qnToken = JSON.parse(qnToken);
                let date = new Date().getTime();
                if (parseInt((date - qnToken.endDate) / 1000 / 60) <= 50) {
                    success(qnToken.token);
                    return;
                }
            }

            this.requestApi(
                {
                    url: '/AohyWebchatS/qiniu/getSimpleToken/wxtrace.do'
                },
                res => {
                    if (res.code === 200) {
                        let token = res.data;
                        storage['qToken'] = JSON.stringify({
                            token: token,
                            endDate: new Date().getTime()
                        });
                        success(token);
                    } else {
                        this.showToast('获取token失败！', 2000, 'cancel');
                        fail();
                    }
                },
                error => {
                    if (error) {
                        this.showToast('获取token失败！', 2000, 'cancel');
                        fail();
                        imgItem.error = true;
                    }
                }
            );
        },
        /**
         * 上传失败，重新上传
         * @param {Object} index
         */
        reUpload(index) {
            this.uploadImg(this.value[index]);
        },
        /**
         * 删除图片
         * @param {Object} index
         */
        resetImg(index) {
            this.value.splice(index, 1);
            document.getElementById('inputFile').value = '';
        }
    },
    mounted() {
        let o = document.getElementById('upload-img');
        if (o) {
            this.itemWidth = parseInt((o.clientWidth || o.offsetWidth) / 3);
        }
        this.getToken();
    }
};



// WEBPACK FOOTER //
// ./src/components/uploadImg/uploadImg.vue